import React, { useEffect } from "react";
import { connect } from "react-redux";
import { debug } from "../../utils";
import * as modalDataService from './modalDataService'
import * as validationService from "./validationService";

function ApiUsernameField({ apiUsername, anotherSectionActive, error }) {

    useEffect(() => {
        if (anotherSectionActive) {
            validationService.cleanValidation('apiUsername');
            onChange('');
        } else {
            validationService.validateUsername(apiUsername, 'apiUsername');
        }
        return () => validationService.cleanValidation('apiUsername');
    }, [apiUsername, anotherSectionActive])

    const onChange = (value) => modalDataService.changeApiUsername(value)

    return (
        <div className="form-group">
            <div className="oct_form-group oct_form-sm">
                <label htmlFor="username">Username</label>
                <input className={`form-control oct_field ${error && 'border-danger'}`}
                    id="username"
                    value={apiUsername}
                    placeholder="admin"
                    onChange={event => onChange(event.target.value)} />
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("ApiUsernameField mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    const validation = state.validation;
    const anotherSectionActive = !!addDeviceModal.apiKey; //|| !!addDeviceModal.apiUrl;
    return {
        apiUsername: addDeviceModal.apiUsername || '',
        error: validation.apiUsername,
        anotherSectionActive
    }
}

export default connect(mapStateToProps)(ApiUsernameField);
